import React from 'react';
import {ThemeProvider} from '@mui/material';
import theme from './theme';
import CssBaseline from '@mui/material/CssBaseline';
import {useRoutes} from 'react-router';
import router from './router';
import {SidebarProvider} from './contexts/SidebarContext';
import ToastProvider from "./contexts/ToastContext";
import {createBrowserHistory} from 'history';
import './i18n';

export const history = createBrowserHistory();

function App() {
    const content = useRoutes(router());

    return (
        <ThemeProvider theme={theme}>
            <ToastProvider>
                <SidebarProvider>
                    <CssBaseline />
                    {content}
                </SidebarProvider>
            </ToastProvider>
        </ThemeProvider>
    );
}

export default App;
